import styled from 'styled-components';

export const Wrapper = styled.div`
    margin: 0 auto;
    margin-top: 20px;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 1rem;
  align-items: center;
`;
